
var cssLoaded = {};

function loadCss(url) {

    if (cssLoaded[url])
        return;

    var link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = $.agito.baseUrl + url;
    document.getElementsByTagName("head")[0].appendChild(link);

    cssLoaded[url] = true;
}